import { bool, string } from 'prop-types';
import React, { Fragment } from 'react';
import Head from 'next/head';
import {
  JW_AMP_PLAYER_ID,
  JW_AMP_PLAYER_WITH_ADS_ID,
  JW_AMP_RELATED_PLAYER_ID,
  VIDEO_HUB_URL
} from 'constants/video';
import { toUrl } from 'util/link';

function requiredPropsCheck(props, propName, componentName) {
  if (!props.videoId && !props.playlist) {
    return new Error(
      `One of 'videoId' or 'playlist' is required by '${componentName}' component.`
    );
  }
  return undefined;
}

function AmpVideo({ videoId, playlist, hideAds, placement }) {
  let playlistId;
  if (playlist) {
    // If playlist is set, parse the URL and extract the playlist id
    const parsed = toUrl(playlist);
    // Get last path segment
    [, playlistId] = parsed.pathname.match(/([^/]+)\/?$/);
  }
  let dataPlayerId;
  if (placement === 'related') {
    dataPlayerId = JW_AMP_RELATED_PLAYER_ID;
  } else if (hideAds) {
    dataPlayerId = JW_AMP_PLAYER_ID;
  } else {
    dataPlayerId = JW_AMP_PLAYER_WITH_ADS_ID;
  }
  return (
    <Fragment>
      <Head>
        <script
          async
          key="amp-jwplayer"
          custom-element="amp-jwplayer"
          src="https://cdn.ampproject.org/v0/amp-jwplayer-0.1.js"
        />
      </Head>
      {(placement === 'in_post' || placement === 'related') && (
        <div className="AmpVideo__callout">
          <a href={VIDEO_HUB_URL}>Watch</a>
        </div>
      )}
      <amp-jwplayer
        data-player-id={dataPlayerId}
        data-media-id={videoId}
        data-playlist-id={playlistId}
        layout="responsive"
        width="16"
        height="9"
      />
    </Fragment>
  );
}

AmpVideo.defaultProps = {
  videoId: undefined,
  playlist: undefined,
  hideAds: false,
  placement: undefined
};

AmpVideo.propTypes = {
  videoId: requiredPropsCheck,
  playlist: requiredPropsCheck,
  hideAds: bool,
  placement: string
};

export default AmpVideo;
